import { useRef } from "react";
import lotus from "./assets/lotus.png";
import lin from "./assets/lin.jpg";
import "./App.css";
import InfoImageSection from "./components/InfoImageSection";
import { LEFT_ORIENTATION, RIGHT_ORIENTATION } from "./siteUtils";
import FAQ from "./sections/FAQ";
import Testimonials from "./sections/Testimonials";
import Hero from "./sections/Hero";
import BookingForm from "./sections/Booking";
import Services from "./sections/Services";
import { Copyright } from "@mui/icons-material";
import { Helmet } from "react-helmet";
import ScrollProgress from "./components/ScrollProgress";
import BackToTop from "./components/BackToTop";

function App() {
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const testimonialsRef = useRef(null);
  const faqRef = useRef(null);
  const bookRef = useRef(null);

  const links = [
    { title: "about", ref: aboutRef },
    { title: "services", ref: servicesRef },
    { title: "testimonials", ref: testimonialsRef },
    { title: "faq's", ref: faqRef },
    { title: "book", ref: bookRef },
  ];

  return (
    <>
      <Helmet>
        <title>Sacred Cleansing by Linda</title>
        <meta
          name="description"
          content="Expert spiritual cleansing services in Ireland. Clear energy and reset your home, land or business space with Linda's gentle guidance."
        />

        {/* Open Graph (Facebook, LinkedIn, WhatsApp, etc.) */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sacredcleansingbylinda.ie/" />
        <meta property="og:title" content="Sacred Cleansing by Linda" />
        <meta
          property="og:description"
          content="Expert spiritual house and land cleansing across Ireland. Reset your space with Linda’s intuitive energy work."
        />
        <meta
          name="image"
          property="og:image"
          content="https://sacredcleansingbylinda.ie/images/brigadoon-small.jpeg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://sacredcleansingbylinda.ie/" />
        <meta name="twitter:title" content="Sacred Cleansing by Linda" />
        <meta
          name="twitter:description"
          content="Gentle spiritual energy clearing and blessings for homes, land, and businesses in Ireland."
        />
        <meta
          name="twitter:image"
          content="https://sacredcleansingbylinda.ie/images/brigadoon-smaller.jpeg"
        />

        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Sacred Cleansing by Linda",
      "image": ["https://sacredcleansingbylinda.ie/favicon-96x96.png", "https://sacredcleansingbylinda.ie/images/brigadoon-small.jpeg"],
      "url": "https://sacredcleansingbylinda.ie/",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Carlow",
        "addressCountry": "IE"
      },
      "description": "Spiritual house clearing for homes, land and businesses in Ireland.",
      "serviceType": ["Reiki Energy Healing", "Angelic Core Healing", "Soul Renewal Guidance", "Psychic Mediumship Readings", "Spiritual House Cleansing", "Land Energy Clearing"],
      "areaServed": {
        "@type": "Country",
        "name": "Ireland"
      }
    }
    `}
        </script>
      </Helmet>
      <ScrollProgress />
      <main className="App">
        <Hero links={links} />
        <InfoImageSection
          ref={aboutRef}
          orientation={RIGHT_ORIENTATION}
          img={<img src={lin} alt="Linda Rooney, spiritual healer and energy cleanser" />}
          header="About me"
          text="I grew up in a large family and was always the sensitive child.
              From a young age, I had the ability to sense the energy of those
              around me and became very aware of a glowing, translucent light
              surrounding people, places, and nature. As I grew older, I married
              and had two children, but in my mid-thirties, I decided to follow
              my heart and pursued Reiki Healing, achieving the Master Level.
              With my gift of knowledge, I expanded my studies into Angelic Core
              Healing, which further enhanced my psychic abilities. From then
              on, I could see the light of Angels surrounding everyone.
              <br /> Sensing the energy of different places, I was naturally
              drawn to studying geopathic energy cleansing, as I could feel
              which areas needed to be purified. This work brings me immense
              joy, as I find peace in restoring a sense of calmness to homes,
              land, and businesses. With 20 years of experience, I have been
              able to put my skills into practice, providing my clients with the
              tranquility and balance they seek in their homes. I continue my
              mission to spread peace and serenity in everything I do."
        />
        <InfoImageSection
          orientation={LEFT_ORIENTATION}
          img={<img src={lotus} alt="lotus flower" />}
          header="Spiritual Cleansing"
          text="Spiritual cleansing is the practice of removing negative energy from a space to restore harmony, peace, and positive vibrations. Over time, homes and workplaces can accumulate residual energy from past occupants, emotional experiences, and external influences. If you've been feeling drained, experiencing unexplained tension, or sensing a heavy atmosphere in your space, a cleansing ritual can help refresh and realign the energy flow.
<br/>
        Through a combination of Reiki energy, sound healing, and intention-based rituals, spiritual house cleansing purifies stagnant energy, bringing a renewed sense of balance. Many people seek this service when:
        
        Moving into a new home to clear past energies.
        Experiencing unexplained heaviness, disturbances, or stress at home.
        Recovering from a period of emotional hardship or loss.
        Seeking clarity, peace, and alignment with their environment.<br/>
        By incorporating elements such as sage smudging, crystal placements, and vibrational sound therapy, the cleansing process not only removes negativity but also invites in protection, warmth, and spiritual renewal. A spiritually cleansed home feels lighter, more welcoming, and supports overall well-being."
        />
    <Services ref={servicesRef} />
        {/* Testimonials section */}
        <Testimonials ref={testimonialsRef} />
        <FAQ ref={faqRef} />
        <BookingForm ref={bookRef} />
        {/* Footer section */}
        <div
          style={{
            height: 50,
            backgroundColor: "#755673",
            display: "flex",
            padding: "10px 0 10px 20px",
            lineHeight: 1.6,
            alignItems: "center",
            color: "white",
            gap: 10,
          }}
        >
          <Copyright col />
          <span>Sean Rooney</span>
        </div>
      </main>
      <BackToTop />
    </>
  );
}

export default App;
